<template>
  <table class="list">
    <tr class="list__header">
      <th v-for="(head, i) in headers" :key="i">{{ $t(head) }}</th>
    </tr>

    <slot />
  </table>
</template>

<script>
export default {
  props: {
    headers: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
